import { render } from "./LawyerCard.vue?vue&type=template&id=fe1b5efc&scoped=true"
import script from "./LawyerCard.vue?vue&type=script&lang=js"
export * from "./LawyerCard.vue?vue&type=script&lang=js"

import "./LawyerCard.vue?vue&type=style&index=0&id=fe1b5efc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe1b5efc"]])

export default __exports__